module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createpacket"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberredpacket'
      },
      "replace": ""
    }
  }, [_vm._v("会员红包")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建红包")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "红包类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changePacketType
    },
    model: {
      value: (_vm.act_type),
      callback: function($$v) {
        _vm.act_type = $$v
      },
      expression: "act_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "type_payment"
    }
  }, [_vm._v("消费返红包")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "type_share"
    }
  }, [_vm._v("分享红包")])], 1)], 1)], 1), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    ref: "form"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelCreation
    }
  }, [_vm._v("放弃创建")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.preview
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', [_vm._v("提交预览")])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("输入红包信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06b955eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/createpacket/createpacket.vue
// module id = 789
// module chunks = 1